import { TableCell, TableRow } from '@material-ui/core';
import { Checkbox, Dialog, FlatButton, IconButton } from 'material-ui';
import SaveIcon from 'material-ui/svg-icons/content/save';
import UndoIcon from 'material-ui/svg-icons/content/undo';
import * as React from 'react';
import { HashTagModel } from '../../../models'
import { Views } from '../../abstract';

const HashTagsTableViewHeader = [
    { label: 'Наименование' },
    { label: 'Популярность' },
    { label: 'Дата создания' }
]

interface IDashboardHashTagsTableViewProps {
    onSaveEditedTag: (index: number) => void
    onSearchHashTags: (s: string) => void
    defaultHashTagsValues: any[]
    onNewHashTag: (name: string) => void
}

interface IDashboardHashTagsTableViewState {
    selectedRows: object[]
    page: number
    isAddHashTagDialogOpen: boolean
    newHashTagName: string
}

class DashboardHashTagsTableView<P, S> extends Views.TableView<P & IDashboardHashTagsTableViewProps, S & IDashboardHashTagsTableViewState> {

    constructor(props: any) {
        super(props);
        const defaultState: any = {
            selectedRows: [],
            model: this.props.model,
            isDeleteConfirmationDialogOpened: false,
            isAddHashTagDialogOpen: false,
            page: 0,
            newHashTagName: ''
        }
        this.state = defaultState
    }

    public onSearchHashtags(sText: string) {
        const { onSearchHashTags } = this.props;
        onSearchHashTags(sText);
    }

    public onHashTagNameChange(index: number, value: string) {
        const { model } = this.props;
        (model as HashTagModel[])[index].name = value;
        this.setState({ model });
    }

    public onHashTagNameUndo(index: number) {
        const { model, defaultHashTagsValues } = this.props;
        (model as HashTagModel[])[index].name = defaultHashTagsValues[index].name;
        this.setState({ model });
    }

    public rowAtIndex(hashtag: HashTagModel, index: number): JSX.Element {
        const { selectedRows } = this.state;
        const { model, defaultHashTagsValues, onSaveEditedTag } = this.props;
        return (
            <TableRow selected={selectedRows.filter(r => selectedRows.length && r['selected'] === true).length === (model as HashTagModel[]).length || selectedRows.filter(r => r['index'] === index && r['selected'] === true).length ? true : false} key={index.toString()}>
                <TableCell className="checkbox-cell" style={{ width: 30 }}>
                    <Checkbox
                        checked={selectedRows.filter(r => selectedRows.length && r['selected'] === true).length === (model as HashTagModel[]).length || selectedRows.filter(r => r['index'] === index && r['selected'] === true).length ? true : false}
                        onCheck={() => this.onSelectRow(index)}
                    />
                </TableCell>
                <TableCell style={{ minWidth: 50 }}>
                    <Views.TextField
                        name="name"
                        value={hashtag.name}
                        onChange={(e) => this.onHashTagNameChange(index, e.target['value'])}
                    />
                    {hashtag.name !== defaultHashTagsValues[index].name ?
                        <React.Fragment>
                            <IconButton onClick={() => onSaveEditedTag(index)} style={{ verticalAlign: 'middle' }}>
                                <SaveIcon />
                            </IconButton>
                            <IconButton onClick={() => this.onHashTagNameUndo(index)} style={{ verticalAlign: 'middle' }}>
                                <UndoIcon />
                            </IconButton>
                        </React.Fragment>
                        :
                        null
                    }
                </TableCell>
                <TableCell style={{ minWidth: 50 }}>{hashtag.popularity}</TableCell>
                <TableCell style={{ minWidth: 50 }}>{hashtag.createdAt.toLocaleDateString()}</TableCell>
            </TableRow>
        )
    }

    public render_topBar(): JSX.Element {
        const { selectedRows, isAddHashTagDialogOpen, newHashTagName } = this.state;
        const { onNewHashTag } = this.props;
        return (
            <React.Fragment>
                <Views.StandartTableViewTopBar 
                    onSearch={(sText: string) => this.onSearchHashtags(sText)}
                    onAdd={() => this.setState({ isAddHashTagDialogOpen: true })}
                    onDelete={() => this.onDelete()} 
                    deleteDisabled={selectedRows.filter(r => r['selected'] === true).length === 0 ? true : false}
                />
                <Dialog
                    open={isAddHashTagDialogOpen}
                    title="Создать новый хэштег"
                    actions={[
                        <FlatButton onClick={() => { this.setState({ newHashTagName: '', isAddHashTagDialogOpen: false }); onNewHashTag(newHashTagName) }} key="1" label="Сохранить" />,
                        <FlatButton onClick={() => this.setState({ isAddHashTagDialogOpen: false })} key="3" label="Закрыть" />
                    ]}
                >
                    <Views.TextField
                        fullWidth={true}
                        floatingLabelText="Введите наименлвание хэштега"
                        value={newHashTagName}
                        onChange={(e) => this.setState({ newHashTagName: e.target['value'] })}
                    />
                </Dialog>
            </React.Fragment>
        )
    }

    public tableViewHeader() {
        return HashTagsTableViewHeader;
    }

    public labelRowsPerPage() {
        return 'Хэштегов на странице:';
    }
}

export default DashboardHashTagsTableView;



// WEBPACK FOOTER //
// ./src/app/dashboard/hashtags/HashtagsTableView.tsx